var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmhArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1797 31.1786C15.5289 31.8295 14.4736 31.8295 13.8227 31.1786L3.8228 21.1786C3.17193 20.5277 3.17193 19.4724 3.8228 18.8216L13.8227 8.82157C14.4736 8.1707 15.5289 8.17069 16.1797 8.82156C16.8306 9.47244 16.8306 10.5277 16.1798 11.1786L9.02498 18.3334L35.0013 18.3334C35.9218 18.3334 36.668 19.0796 36.668 20.0001C36.668 20.9206 35.9218 21.6667 35.0013 21.6667L9.02498 21.6667L16.1797 28.8216C16.8306 29.4724 16.8306 30.5277 16.1797 31.1786Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmhArrowLeft);
export default __webpack_public_path__ + "static/media/fmh-arrow-left.398ea7dfbe42c5f1c1265cb0a901db52.svg";
export { ForwardRef as ReactComponent };